import { render, staticRenderFns } from "./Masters.vue?vue&type=template&id=37b7b101"
import script from "./Masters.vue?vue&type=script&lang=js"
export * from "./Masters.vue?vue&type=script&lang=js"
import style0 from "./Masters.vue?vue&type=style&index=0&id=37b7b101&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports